/**
 * The app version (package.json "version"). craco.config.js sets
 * REACT_APP_VERSION from package.json at build time and CRA inlines it, so
 * package.json itself is not bundled.
 */
export const APP_VERSION = process.env.REACT_APP_VERSION || "N/A";

export default APP_VERSION;
